module.exports = __webpack_public_path__ + "static/media/แบบคำขอสิทธิ์การเข้าใช้งานระบบPDMO_PORTAL.a2feb524.pdf";